<button class="button--secondary flex items-center" (click)="goToRoute()" [disabled]="loading">
    <i class="material-icons color-white" *ngIf="!loading">arrow_back_ios</i>
    <span *ngIf="loading" class="spinner-border spinner-border-sm mr-1"></span>
    {{'GENERAL.BACK' | translate}}
</button>